import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './StudentApplicationForm.css';

const StudentApplicationForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const jobTitleFromState = location.state?.jobTitle || '';

  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    email: '',
    gender: '',
    dob: '',
    education: '',
    percentage: '',
    skills: '',
    latestResume: null,
    jobTitle: jobTitleFromState, // Store job title here
  });

  useEffect(() => {
    if (jobTitleFromState) {
      setFormData((prev) => ({ ...prev, jobTitle: jobTitleFromState }));
    }
  }, [jobTitleFromState]);

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === 'file') {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleReset = () => {
    setFormData({
      name: '',
      mobile: '',
      email: '',
      gender: '',
      dob: '',
      education: '',
      percentage: '',
      skills: '',
      latestResume: null,
      jobTitle: jobTitleFromState,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = new FormData();
    Object.keys(formData).forEach((key) => {
      form.append(key, formData[key]);
    });

    try {
      const res = await fetch("/api/students/apply", {
        method: "POST",
        body: form,
      });

      const result = await res.json();
      if (res.ok) {
        if (window.confirm("Your application was submitted successfully! Click OK to continue.")) {
          navigate("/careers");
        }
      } else {
        alert("Submission failed: " + result.message);
      }
    } catch (err) {
      alert("Server error: " + err.message);
    }
  };

  return (
    <div className="student-form-container">
      
      <h2>Job Application Form</h2>
      
    
<form className="student-form" onSubmit={handleSubmit} onReset={handleReset}>
  <div className="form-group">
    <label>Name</label>
    <input
      type="text"
      name="name"
      placeholder=" "
      value={formData.name}
      onChange={handleChange}
      required
    />
  </div>

  <div className="form-group">
    <label>Mobile</label>
    <input
      type="tel"
      name="mobile"
      placeholder=" "
      value={formData.mobile}
      onChange={e => {
        // Only allow digits
        const value = e.target.value.replace(/\D/g, '');
        setFormData({ ...formData, mobile: value });
      }}
      pattern="^\d{10}$"
      maxLength={10}
      required
    />
  </div>

  <div className="form-group">
    <label>Email</label>
    <input
      type="email"
      name="email"
      placeholder=" "
      value={formData.email}
      onChange={e => {
        // Allow only letters, numbers, @, and .
        const value = e.target.value.replace(/[^a-zA-Z0-9@.]/g, '');
        setFormData({ ...formData, email: value });
      }}
      pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
      required
    />
  </div>

  <div className="form-group">
    <label>Gender</label>
    <select name="gender" value={formData.gender} onChange={handleChange} required>
      <option value="" disabled hidden></option>
      <option value="Male">Male</option>
      <option value="Female">Female</option>
      <option value="Other">Other</option>
    </select>
  </div>

  <div className="form-group">
    <label>Date of Birth</label>
    <input
      type="date"
      name="dob"
      placeholder=" "
      value={formData.dob}
      onChange={handleChange}
      required
    />
  </div>

 <div className="form-group">
  <label>Education</label>
  <select
    name="education"
    value={formData.education}
    onChange={handleChange}
    required
  >
    <option value="" disabled hidden></option>
    <option value="SSLC">SSLC</option>
    <option value="PUC">PUC</option>
    <option value="Diploma">Diploma</option>
    <option value="Degree">Degree</option>
    <option value="Other">Other</option>
  </select>
</div>

{/* Show input only if "Other" is selected */}
{formData.education === "Other" && (
  <div className="form-group">
    <label>Enter Education</label>
    <input
      type="text"
      name="percentage"
      placeholder="Enter your education"
      value={formData.percentage}
      onChange={handleChange}
      required
    />
  </div>
)}


  <div className="form-group full-width">
    <label>Upload Resume</label>
    <input
      type="file"
      name="latestResume"
      accept=".pdf,.doc,.docx"
      onChange={handleChange}
      required
    />
  </div>

  <div className="form-group full-width">
    <label>Skills</label>
    <textarea
      name="skills"
      placeholder=" "
      value={formData.skills}
      onChange={handleChange}
    />
  </div>

  <div className="button-group">
    <button type="submit" className="submit-btn">Submit</button>
    <button type="reset" className="reset-btn">Reset</button>
    <button type="button" className="reset-btn" onClick={() => navigate('/careers')}>Cancel</button>
  </div>
</form>


    </div>
  );
};

export default StudentApplicationForm;
